import {HttpClient, HttpHeaders} from "@angular/common/http";
import {throwError, Observable} from "rxjs";
//import {param} from "jquery";
import { Injectable } from "@angular/core";
import {tap, catchError, map} from 'rxjs/operators';
import { environment } from "../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  [x: string]: any;
    private domain = environment.apiUrl
    public apiurl;
    // Headers Setup
    headers = new HttpHeaders()
        .set("Content-Type", "application/json")
        .set("Accept", "application/json");
    httpOptions = {
        headers: this.headers,
    };
    constructor(private http: HttpClient) {
    }
    // Handling Errors
    private handleError(error: any) {
        return throwError(error);
    }
// registerUser(user){
//   console.log(this.http.post<any>(this._registerUrl,user));
//   return this.http.post<any>(this._registerUrl,user)
// }
loginUser(user): Observable<any>{
       //console.log(user);
  //console.log(this.http.post<any>(this._loginUrl, user));
  // return this.http.post<any>(this._loginUrl,user).pipe(tap());
    this.apiurl = this.domain + `api/login`;
   // console.log(this.apiurl);
    return this.http
        .post<any>(this.apiurl, user)
        .pipe(tap(), catchError(this.handleError));
}
loggedIn(){
  return !!localStorage.getItem('token')
}
loggedRoles(){
  return !!localStorage.getItem('role')
}

getToken(){
  return localStorage.getItem('token')
  
}
logoutUser(){
  localStorage.removeItem('token')
  this.route.navigate(['/login'])
}
}
